import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ToastProvider } from './contexts/ToastContext';
import { AuthProvider } from './contexts/AuthContext';
import RootRedirect from './routes/RootRedirect';
import { useTelegramBackButton } from './utils/useTelegramBackButton';
import ManagerAuthPage from './routes/ManagerAuthPage';
import ProtectedRoute from './routes/ProtectedRoute';
import ManagerDashboardPage from './routes/ManagerDashboardPage';
import ManagerMarketFormPage from './routes/ManagerMarketFormPage';
import ManagerProductsPage from './routes/ManagerProductsPage';
import ManagerProductPage from './routes/ManagerProductPage';
import ManagerMarketsPage from './routes/ManagerMarketsPage';
import ManagerMarketPage from './routes/ManagerMarketPage';
import SellerAuthPage from './routes/SellerAuthPage';
import SellerDashboardPage from './routes/SellerDashboardPage';
import SellerSettingsPage from './routes/SellerSettingsPage';
import SellerMarketEditPage from './routes/SellerMarketEditPage';
import SellerProductsPage from './routes/SellerProductsPage';
import SellerProductPage from './routes/SellerProductPage';
import SellerProductFormPage from './routes/SellerProductFormPage';
import SellerOrderDetailsPage from './routes/SellerOrderDetailsPage';
import SellerRequisitesPage from './routes/SellerRequisitesPage';

function TelegramRouterEffects() {
  useTelegramBackButton();
  return null;
}

const AppRouter = () => {
  return (
    <Router>
      <TelegramRouterEffects />
      <AuthProvider>
        <ToastProvider>
            <Routes>
              <Route path="/manager/login" element={<ManagerAuthPage />} />
              <Route path="/seller/login" element={<SellerAuthPage />} />

              <Route element={<ProtectedRoute allowedRole="manager" />}>
                <Route path="/manager/dashboard" element={<ManagerDashboardPage />} />
                <Route path="/manager/market" element={<ManagerMarketFormPage />} />
                <Route path="/manager/market/:id" element={<ManagerMarketFormPage />} />
                <Route path="/manager/markets" element={<ManagerMarketsPage />} />
                <Route path='/manager/products' element={<ManagerProductsPage />} />
                <Route path='/manager/product/:id' element={<ManagerProductPage />} />
                <Route path='/manager/market/info/:id' element={<ManagerMarketPage />} />
              </Route>

              <Route element={<ProtectedRoute allowedRole="seller" />}>
                <Route path="/seller/dashboard" element={<SellerDashboardPage />} />
                <Route path="/seller/order/info/:id" element={<SellerOrderDetailsPage />} />
                <Route path="/seller/setting" element={<SellerSettingsPage />} />
                <Route path="/seller/market" element={<SellerMarketEditPage />} />
                <Route path="/seller/products" element={<SellerProductsPage />} />
                <Route path='/seller/product/:id' element={<SellerProductPage />} />
                <Route path="/seller/product/create" element={<SellerProductFormPage />} />
                <Route path="/seller/product/:id/edit" element={<SellerProductFormPage />} />
                <Route path="/seller/requisites" element={<SellerRequisitesPage />} />
              </Route>

              <Route path="/" element={<RootRedirect />} />
            </Routes>
        </ToastProvider>
      </AuthProvider>
    </Router>
  );
};

export default AppRouter;